import { render, staticRenderFns } from "./MainPanel.vue?vue&type=template&id=973e7e68&"
import script from "./MainPanel.vue?vue&type=script&lang=ts&"
export * from "./MainPanel.vue?vue&type=script&lang=ts&"
import style0 from "./MainPanel.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports